import React from 'react';
import ReactMarkdown from 'react-markdown';
import { cx } from '../../utils/cx.js';

// Headings inside an entry stay below the category title (h3) in the outline.
const Heading = ({ children }) => <h4 className="mb-1 mt-3 text-sm font-semibold text-gray-900 dark:text-white">{children}</h4>;

// Analysis prompts put product names and prices in italics: they get the brand color.
const COMPONENTS = {
  p: ({ node, ...props }) => <p className="my-2 first:mt-0 last:mb-0" {...props} />,
  strong: ({ node, ...props }) => <strong className="font-semibold text-gray-900 dark:text-white" {...props} />,
  em: ({ node, ...props }) => <em className="font-medium text-brand-700 dark:text-brand-300" {...props} />,
  ul: ({ node, ...props }) => <ul className="my-2 list-disc space-y-1 pl-5 marker:text-brand-400 first:mt-0 last:mb-0" {...props} />,
  ol: ({ node, ...props }) => <ol className="my-2 list-decimal space-y-1 pl-5 marker:font-semibold marker:text-gray-400 first:mt-0 last:mb-0" {...props} />,
  li: ({ node, ...props }) => <li className="pl-1" {...props} />,
  a: ({ node, children, ...props }) => (
    <a className="font-medium text-brand-600 underline decoration-brand-300 underline-offset-2 hover:text-brand-700 dark:text-brand-400" target="_blank" rel="noopener noreferrer" {...props}>{children}</a>
  ),
  h1: ({ node, children }) => <Heading>{children}</Heading>,
  h2: ({ node, children }) => <Heading>{children}</Heading>,
  h3: ({ node, children }) => <Heading>{children}</Heading>,
  h4: ({ node, children }) => <Heading>{children}</Heading>,
  blockquote: ({ node, ...props }) => <blockquote className="my-2 border-l-2 border-brand-200 pl-3 italic text-gray-600 dark:border-brand-800 dark:text-gray-400" {...props} />,
  code: ({ node, ...props }) => <code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[13px] dark:bg-white/10" {...props} />,
  hr: ({ node, ...props }) => <hr className="my-3 border-gray-200 dark:border-gray-800" {...props} />,
};

/** Analysis markdown with the app typography. Literal "\n" sequences from the AI become newlines. */
const Markdown = ({ children, className = '' }) => (
  <div className={cx('text-[15px] leading-relaxed text-gray-700 dark:text-gray-300', className)}>
    <ReactMarkdown components={COMPONENTS}>{String(children ?? '').replace(/\\n/g, '\n')}</ReactMarkdown>
  </div>
);

export default Markdown;
